export var LogLevels;
(function (LogLevels) {
    LogLevels["DEBUG"] = "debug";
    LogLevels["INFO"] = "info";
    LogLevels["WARN"] = "warn";
    LogLevels["ERROR"] = "error";
})(LogLevels || (LogLevels = {}));
